const routes = [
  {
    path: "/alert-system",
    name: "alert-system",
    component: () =>
      import("@/views/pages/admin/report-alert/GeneratedAlertsList.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/alert-system/:id",
    name: "alert-system-edit",
    component: () =>
      import("@/views/pages/admin/report-alert/GeneratedAlertView.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  // Admin Routes
  {
    path: "/admin/edit-group-site/:id?",
    name: "admin-edit-group-site",
    component: () =>
      import("@/views/pages/admin/group-site/GroupSiteCreateOrUpdate"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/group-site-list",
    name: "admin-list-group-site",
    component: () => import("@/views/pages/admin/group-site/GroupSiteList"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  // Admin / Sites :
  {
    path: "/admin/list-site",
    name: "admin-list-site",
    component: () => import("@/views/admin/site/SiteList"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/create-email-report",
    name: "admin-create-email-report",
    component: () =>
      import("@/views/pages/admin/email-report/EmailReportCreate"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/list-email-report",
    name: "admin-list-email-report",
    component: () => import("@/views/pages/admin/email-report/EmailReportList"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/create-alert-report",
    name: "admin-create-alert-report",
    component: () =>
      import("@/views/pages/admin/report-alert/ReportAlertCreate"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/list-alert-report",
    name: "admin-list-alert-report",
    component: () => import("@/views/pages/admin/report-alert/ReportAlertList"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/audience-backfill",
    name: "admin-audience-backfill",
    component: () => import("@/views/pages/admin/AdnAudienceBackfill.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/admin/workflows",
    name: "admin-aiflow-start-dag",
    component: () => import("@/views/pages/admin/Airflow.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/admin/airflow-alerts",
    name: "admin-airflow-alerts",
    component: () => import("@/views/pages/admin/AirflowAlerts.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/admin/marmiton-ingredient-groups",
    name: "admin-marmiton-list-ingredient-groups",
    component: () => import("@/views/admin/marmiton/IngredientGroups.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/admin/marmiton-create-ingredient-group",
    name: "admin-marmiton-create-ingredient-group",
    component: () => import("@/views/admin/marmiton/CreateOrUpdate.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/admin/marmiton-edit-ingredient-group/:id",
    name: "admin-marmiton-edit-ingredient-group",
    component: () => import("@/views/admin/marmiton/CreateOrUpdate.vue"),
    meta: {
      layout: "content",
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/admin/data-availability",
    name: "admin-data-availability",
    component: () =>
      import("@/views/pages/admin/data-availability/DataAvailability.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/llm-models",
    name: "admin-llpr-models",
    component: () => import("@/views/admin/llpr/LlmModelsList.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/prompt-contexts",
    name: "admin-llpr-contexts",
    component: () => import("@/views/admin/llpr/PromptContextsList.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/post-create",
    name: "admin-post-create",
    component: () => import("@/views/admin/ai-factory/PostCreate.vue"),
    meta: {
      layout: "content",
      resource: ["admin", "ai_factory"],
      action: "manage",
    },
  },
  {
    path: "/admin/prompt-config",
    name: "admin-prompt-config",
    component: () => import("@/views/admin/ai-factory/PromptConfig.vue"),
    meta: {
      layout: "content",
      resource: ["admin", "ai_factory"],
      action: "manage",
    },
  },
  {
    path: "/admin/prompt-config-new",
    name: "admin-prompt-config-new",
    component: () =>
      import("@/views/admin/ai-factory/promptConfigNewSystem.vue"),
    meta: {
      layout: "content",
      resource: ["admin", "ai_factory"],
      action: "manage",
    },
  },
  {
    path: "/admin/prompt-config-all",
    name: "admin-prompt-config-all",
    component: () => import("@/views/admin/llpr/AllPromptFamilies.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/ai-factory/internal-linking",
    name: "admin-aif-internal-linking",
    component: () =>
      import("@/views/admin/ai-factory/InternalLinkingSites.vue"),
    meta: {
      layout: "content",
      resource: ["admin", "ai_factory"],
      action: "manage",
    },
  },
  {
    path: "/admin/ai-factory/queue-config",
    name: "admin-aif-queue-config",
    component: () => import("@/views/admin/ai-factory/QueueConfig.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  {
    path: "/admin/ai-factory/transcription-config",
    name: "admin-aif-transcription-config",
    component: () => import("@/views/admin/ai-factory/TranscriptionConfig.vue"),
    meta: {
      layout: "content",
      // Superadmin ("all"), pas "admin" : le back garde cette config avec
      // all_manage_dict, et un reglage ici change la brique de TOUS les
      // process video. A ouvrir en meme temps que la page video.
      resource: "all",
      action: "manage",
    },
  },
  {
    path: "/admin/system/ram-snapshots",
    name: "admin-system-ram-snapshots",
    component: () => import("@/views/admin/system/RamSnapshots.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
  // Exports
  {
    path: "/admin/exports",
    name: "admin-exports",
    component: () => import("@/views/admin/exports/Exports.vue"),
    meta: {
      layout: "content",
      resource: "admin",
      action: "manage",
    },
  },
];

export default routes;
